export * from './sidebar.directive';



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/directives/sidebar/index.ts